<div class="mt-xl-10 mt-2">
  <mfa-reg-step (submit)="onSubmit()"></mfa-reg-step>
</div>
